// Utility function to convert article title to URL-friendly slug
export const titleToSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

// Blog articles data with translation keys
export const blogArticles = [
  {
    id: 18,
    slug: "why-your-brain-is-better-at-languages-than-you-think",
    titleKey: "blogArticle18Title",
    excerptKey: "blogArticle18Excerpt",
    contentKey: "blogArticle18Content",
    authorKey: "blogArticle18Author",
    date: "2025-12-26"
  },
  {
    id: 17,
    slug: "why-learning-a-new-language-is-actually-a-gift-to-yourself",
    titleKey: "blogArticle17Title",
    excerptKey: "blogArticle17Excerpt",
    contentKey: "blogArticle17Content",
    authorKey: "blogArticle17Author",
    date: "2025-12-18"
  },
  {
    id: 16,
    slug: "the-ghost-in-the-machine-why-your-brain-cant-hear-new-languages-yet",
    titleKey: "blogArticle16Title",
    excerptKey: "blogArticle16Excerpt",
    contentKey: "blogArticle16Content",
    authorKey: "blogArticle16Author",
    date: "2025-12-11"
  },
  {
    id: 15,
    slug: "the-architecture-of-thought-does-your-language-change-your-reality",
    titleKey: "blogArticle15Title",
    excerptKey: "blogArticle15Excerpt",
    contentKey: "blogArticle15Content",
    authorKey: "blogArticle15Author",
    date: "2025-12-02"
  },
  {
    id: 14,
    slug: "why-you-dont-sound-like-you-in-another-language-and-why-thats-not-a-bad-thing-at-all",
    titleKey: "blogArticle14Title",
    excerptKey: "blogArticle14Excerpt",
    contentKey: "blogArticle14Content",
    authorKey: "blogArticle14Author",
    date: "2025-11-25"
  },
  {
    id: 13,
    slug: "why-your-brain-actually-learns-better-in-a-little-bit-of-chaos",
    titleKey: "blogArticle13Title",
    excerptKey: "blogArticle13Excerpt",
    contentKey: "blogArticle13Content",
    authorKey: "blogArticle13Author",
    date: "2025-11-19"
  },
  {
    id: 12,
    slug: "the-secret-map-your-brain-uses-to-remember-things-and-why-location-might-be-sabotaging-your-language-learning",
    titleKey: "blogArticle12Title",
    excerptKey: "blogArticle12Excerpt",
    contentKey: "blogArticle12Content",
    authorKey: "blogArticle12Author",
    date: "2025-11-10"
  },
  {
    id: 11,
    slug: "how-to-practice-speaking-when-you-have-no-one-to-talk-to",
    titleKey: "blogArticle11Title",
    excerptKey: "blogArticle11Excerpt",
    contentKey: "blogArticle11Content",
    authorKey: "blogArticle11Author",
    date: "2025-11-03"
  },
  {
    id: 10,
    slug: "the-plateau-problem-why-you-stop-progressing-and-how-to-break-through",
    titleKey: "blogArticle10Title",
    excerptKey: "blogArticle10Excerpt",
    contentKey: "blogArticle10Content",
    authorKey: "blogArticle10Author",
    date: "2025-10-28"
  },
  {
    id: 9,
    slug: "the-best-time-of-day-to-study-a-language-according-to-science",
    titleKey: "blogArticle9Title",
    excerptKey: "blogArticle9Excerpt",
    contentKey: "blogArticle9Content",
    authorKey: "blogArticle9Author",
    date: "2025-10-18"
  },
  {
    id: 8,
    slug: "flashcards-vs-gamification-which-method-gets-you-fluent-faster",
    titleKey: "blogArticle8Title",
    excerptKey: "blogArticle8Excerpt",
    contentKey: "blogArticle8Content",
    authorKey: "blogArticle8Author",
    date: "2025-10-12"
  },
  {
    id: 7,
    slug: "neuroplasticity-and-language-can-you-actually-learn-a-language-as-an-adult",
    titleKey: "blogArticle7Title",
    excerptKey: "blogArticle7Excerpt",
    contentKey: "blogArticle7Content",
    authorKey: "blogArticle7Author",
    date: "2025-10-05"
  },
  {
    id: 6,
    slug: "why-consistency-beats-intensity-in-language-learning",
    titleKey: "blogArticle6Title",
    excerptKey: "blogArticle6Excerpt",
    contentKey: "blogArticle6Content",
    authorKey: "blogArticle6Author",
    date: "2025-09-29"
  },
  {
    id: 5,
    slug: "the-role-of-culture-in-language-why-you-cant-just-learn-vocabulary",
    titleKey: "blogArticle5Title",
    excerptKey: "blogArticle5Excerpt",
    contentKey: "blogArticle5Content",
    authorKey: "blogArticle5Author",
    date: "2025-09-23"
  },
  {
    id: 4,
    slug: "top-5-mistakes-beginners-make-when-learning-a-new-language-and-how-to-avoid-them",
    titleKey: "blogArticle4Title",
    excerptKey: "blogArticle4Excerpt",
    contentKey: "blogArticle4Content",
    authorKey: "blogArticle4Author",
    date: "2025-09-16"
  },
  {
    id: 3,
    slug: "active-recall-vs-passive-review-why-your-current-study-method-is-lying-to-you",
    titleKey: "blogArticle3Title",
    excerptKey: "blogArticle3Excerpt",
    contentKey: "blogArticle3Content",
    authorKey: "blogArticle3Author",
    date: "2025-09-13"
  },
  {
    id: 2,
    slug: "how-to-build-a-10-minute-daily-language-habit-that-actually-sticks",
    titleKey: "blogArticle2Title",
    excerptKey: "blogArticle2Excerpt",
    contentKey: "blogArticle2Content",
    authorKey: "blogArticle2Author",
    date: "2025-09-05"
  },
  {
    id: 1,
    slug: "the-science-of-memory-why-we-forget-70-percent-of-what-we-learn",
    titleKey: "blogArticle1Title",
    excerptKey: "blogArticle1Excerpt",
    contentKey: "blogArticle1Content",
    authorKey: "blogArticle1Author",
    date: "2025-09-01"
  }
];

// Function to get article by slug with translations
export const getArticleBySlug = (slug, t) => {
  const article = blogArticles.find(article => article.slug === slug);
  if (!article) return null;

  return {
    ...article,
    title: t(article.titleKey) || article.titleKey,
    excerpt: t(article.excerptKey) || article.excerptKey,
    content: t(article.contentKey) || article.contentKey,
    author: t(article.authorKey) || article.authorKey
  };
};

// Function to get all articles with translations (sorted by date, newest first)
export const getAllArticles = (t) => {
  return [...blogArticles]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .map(article => ({
      ...article,
      title: t(article.titleKey) || article.titleKey,
      excerpt: t(article.excerptKey) || article.excerptKey,
      author: t(article.authorKey) || article.authorKey
    }));
};

